import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';
import { getUser, clearAuth } from '../utils/authUtil';
import { usePopup } from '../context/PopupContext';

const Sidebar = ({ mobileOpen, setMobileOpen, isManaged }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showConfirm } = usePopup();

  const handleLogout = async () => {
    const confirmed = await showConfirm('Logout', 'Are you sure you want to logout?');
    if (confirmed) {
      clearAuth();
      navigate('/');
    }
  };

  const user = getUser();
  const isSuper = user?.realRole === 'super_admin';

  const navItems = isSuper ? [
    { path: '/super-admin', label: 'Platform Stats', icon: '🌐' },
    { path: '/super-admin?tab=colleges', label: 'Colleges', icon: '🏛️' },
    { path: '/super-admin?tab=companies', label: 'Companies', icon: '🏢' },
    { path: '/admin/students', label: 'Students', icon: '👥' },
    { path: '/super-admin/questions', label: 'Global Question Bank', icon: '❓' },
    { path: '/admin/tests', label: 'Tests', icon: '📋' },
    { path: '/admin/diagnostic-analysis', label: 'Diagnostic Analysis', icon: '🔬' },
  ] : [
    { path: '/admin/dashboard', label: 'Dashboard', icon: '▣' },
    { path: '/admin/students', label: 'Students', icon: '👥' },
    { path: '/admin/questions', label: 'Question Bank', icon: '❓' },
    { path: '/admin/tests', label: 'Tests', icon: '📋' },
    { path: '/admin/diagnostic-analysis', label: 'Diagnostic Analysis', icon: '🔬' },
    { path: '/admin/analytics', label: 'Analytics', icon: '📊' },
  ];

  // Precise active check using React Router's live location object
  const isItemActive = (itemPath) => {
    const [pathPart, queryPart] = itemPath.split('?');
    const currentPath = location.pathname;
    const currentSearch = location.search; // e.g. "?tab=colleges"

    if (queryPart) {
      // Items with query params (Colleges, Companies): must match BOTH path AND query
      return currentPath === pathPart && currentSearch === `?${queryPart}`;
    }

    if (itemPath === '/super-admin') {
      // Platform Stats: active ONLY when on /super-admin with NO query string
      return currentPath === '/super-admin' && currentSearch === '';
    }

    // All other normal paths: exact path or child paths
    return currentPath === pathPart || currentPath.startsWith(pathPart + '/');
  };

  return (
    <>
      <div className={`sidebar ${mobileOpen ? 'mobile-open' : ''}`}>
        <div className="sidebar-logo">
          <div className="logo-icon">P</div>
          <span>Zaptude</span>
          <button className="mobile-sidebar-close" onClick={() => setMobileOpen(false)}>×</button>
        </div>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <a
              key={item.path}
              href={item.path}
              className={`nav-item ${isItemActive(item.path) ? 'active' : ''}`}
              onClick={(e) => {
                e.preventDefault();
                setMobileOpen(false);
                navigate(item.path);
              }}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </a>
          ))}
        </nav>

        <button className="sidebar-logout" onClick={handleLogout}>
          <span className="logout-icon">⬡</span> Logout
        </button>
      </div>
    </>
  );
};

export default Sidebar;